import React from 'react';
const bonuses = [{
  emoji: '⚖️',
  title: 'Guide to Load & Dosage',
  desc: 'Take the guesswork out of sets and reps for every goal.'
}, {
  emoji: '📅',
  title: 'Annual High-Performance Map',
  desc: "Plan your studio's entire year in one sitting."
}, {
  emoji: '✅',
  title: 'Student Progress Trackers',
  desc: 'Give your clients proof they are getting stronger.'
}, {
  emoji: '🎵',
  title: '"Energy & Flow" Playlists',
  desc: 'Curated Spotify and Apple Music links for every type of session.'
}, {
  emoji: '🏆',
  title: 'Achievement Certificates',
  desc: 'Recognise student level-ups — the secret to long-term retention.'
}, {
  emoji: '🤝',
  title: 'Inclusive Modification Kit',
  desc: 'Safe variations for students that need a slower pace.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <div className="text-center mb-14" data-id="element-12">
          <span className="text-4xl mb-4 block" data-id="element-13">🔥</span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-3 tracking-tight" data-id="element-14">
            6 Exclusive Bonuses Included
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-15">
            Total Value $552 AUD —{' '}
            <span className="text-primary font-bold" data-id="element-16">FREE ONLY TODAY</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-[0_8px_20px_rgba(201,137,155,0.08)] group" data-id="element-18">
              {/* Emoji Badge */}
              <div className="w-12 h-12 rounded-xl bg-bg-alt border border-border-light flex items-center justify-center flex-shrink-0 text-2xl group-hover:bg-primary/10 transition-colors" data-id="element-19">
                {bonus.emoji}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-20">
                <h4 className="text-text-main font-bold text-base sm:text-lg mb-1" data-id="element-21">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm leading-relaxed" data-id="element-22">
                  {bonus.desc}
                </p>
              </div>

              {/* FREE badge */}
              <span className="bg-primary/10 text-primary border border-primary/20 px-2 py-1 rounded-md font-bold text-xs flex-shrink-0" data-id="element-23">
                FREE
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}